module.exports = __webpack_public_path__ + "img/jf19.a63d69d3.jpg";